<template>
  <div style="text-align: center;">
    <y-shelf title="拉黑设计师">
      <div slot="content" class="desHeader">
        <div style="height: 600px;">
          <div class="transfer">
            <el-row :gutter="0" class="condition-table">
              <!-- 左侧 -->
              <el-col :span="10" style="padding-left:0">
                <div class="no-add">
                  <span>候选列表</span>
                </div>
                <div style="width: 100%;height: 40px;">
                  <el-input class="el-transfer-panel__filter" v-model="queryLeftParam.nickName"
                            size="small" placeholder="请输入设计师名称" @input="filterLeftParam">
                    <i slot="prefix" class="el-icon-search search-position"></i>
                  </el-input>
                </div>
                <el-table ref="staffTable" border v-loading="loading"
                          style="height: 500px;overflow-y: auto;"
                          :row-key="getRowKey" :data="leftDesList"
                          @selection-change="handleStaffChange"
                          :header-cell-style="{ background: '#f5f8ff' }">
                  <el-table-column type="selection" align="center" :reserve-selection="true"
                                   width="55"></el-table-column>
                  <el-table-column label="编号" align="center" show-overflow-tooltip>
                    <template slot-scope="{ row }">
                      <span>{{ row.userCode }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="名称" align="center" show-overflow-tooltip>
                    <template slot-scope="{row}">
                      <span>{{ row.nickName }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" show-overflow-tooltip>
                    <template slot-scope="{row}">
                      <el-button @click="addItemToRightList({ row })">添加</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="table-footer">
                  <el-pagination @current-change="leftPageNum" :pager-count="5"
                                 :current-page.sync="queryLeftParam.pageNum"
                                 :page-size="queryLeftParam.pageSize" layout="prev, pager, next"
                                 :total="leftTotal" style="margin-top: 1%;">
                  </el-pagination>
                </div>
              </el-col>
              <!-- 多选移动箭头图标 -->
              <div class="icon-center">
                <p :class="['icon-return', selectLeftData.length > 0 ? 'icon-right-if' : 'icon-right-else']"
                   @click="selectLeftData.length > 0 && batchAddToRightList()">
                  <i class="el-icon-arrow-left"></i>
                </p>
                <p :class="selectRightData.length > 0 ? 'icon-right-if' : 'icon-right-else'"
                   @click="selectRightData.length > 0 && removeStaff()">
                  <i class="el-icon-arrow-left"></i>
                </p>
              </div>
              <!-- 右侧 -->
              <el-col :span="10" style="padding-right:0">
                <div class="no-add">
                  <span>拉黑列表</span>
                </div>
                <div style="width:100%;height: 40px;">
                  <el-input class="el-transfer-panel__filter" v-model="queryRightParam.nickName"
                            size="small" placeholder="请输入设计师名称" @input="filterRightParam">
                    <i slot="prefix" class="el-icon-search search-position"></i>
                  </el-input>
                </div>
                <el-table ref="selectedStaffTable" border v-loading="loading"
                          :row-key="getRowKey" :data="rightDesList"
                          @selection-change="handleSelectedStaffChange"
                          :header-cell-style="{ background: '#f5f8ff' }"
                          style="height: 500px;overflow-y: auto;">
                  <el-table-column type="selection" align="center" :reserve-selection="true"
                                   width="55"></el-table-column>
                  <el-table-column label="编号" align="center" show-overflow-tooltip>
                    <template slot-scope="{ row }">
                      <span>{{ row.userCode}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="名称" align="center" show-overflow-tooltip>
                    <template slot-scope="{row}">
                      <span>{{ row.nickName }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="服务单类型" align="center" show-overflow-tooltip>
                    <template slot-scope="{row}">
                      <span>{{ getServCataNames(row.servCataId) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" show-overflow-tooltip>
                    <template slot-scope="{row}">
                      <el-button @click="addItemToLeftList({ row })">移除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="table-footer">
                  <el-button class="handle-btn" type="primary" plain size="mini"
                             @click="handleSubmit">保存
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </y-shelf>
    <el-dialog
      :visible.sync="dialogFlag"
      width="600px"
      center
      title='添加服务单类型'
      class="order-dialog">
      <div class="order-content">
        <div class="search-item" style="display: flex;justify-content: center;align-items: center;margin: 25px 0">
          选择服务单类型&#xff1a;<el-cascader v-model="queryParams.servCataId" :options="common.category"
                                             :props="optionProps"
                                             :show-all-levels="false" :popper-append-to-body="false"
                                             popper-class="order-cascader-popper"
                                             placeholder="请选择服务单类型"
                                             >
        </el-cascader>
        </div>
      </div>
      <!-- 底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFlag = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import YShelf from '/components/YShelf';
import {mapState} from "vuex";

export default {
  data() {
    return {
      queryRightParam: {
        nickName: '',
      },
      queryLeftParam: {
        pageNum: 1,
        pageSize: 30,
        nickName: '',
      },
      unChangeRight: [],//获取后的右侧列表数据（未删除的原始数据）
      leftDesList: [],//左边表格数据
      rightDesList: [], //右边表格数据
      selectLeftData: [],//左边选中列表
      selectRightData: [],//右边选中列表
      dialogFlag: false,
      loading: false,
      leftTotal: 0,
      leftList: [],//没有分页检索的全部des数据
      rightList: [],//筛选前右列表（搜索基准）
      user_id: '',//右侧列表当前用户id
      inviteDesList: [],//邀约列表
      queryParams: {
        servCataId: [],
        row: []
      },
      optionProps: {
        value: 'servId',
        label: 'servName',
        children: 'children',
        expandTrigger: 'hover',
        multiple: true,
      },
    };
  },
  methods: {
    // 通用过滤方法
    _filterByKeyword(list, keyword) {
      if (!keyword || !keyword.trim()) return list;
      const key = keyword.trim();
      return list.filter(item =>
        (item.nickName && item.nickName.includes(key)) ||
        (item.userCode && item.userCode.toString().includes(key))
      );
    },
    // 通用脱敏+拷贝
    _mapWithShowName(list) {
      return list.map(item => ({ ...item, nickName: this.showName(item.nickName) }));
    },
    // 左侧分页切片
    _sliceLeftList() {
      const { pageNum, pageSize } = this.queryLeftParam;
      const start = (pageNum - 1) * pageSize;
      return this._mapWithShowName(this.leftList.slice(start, start + pageSize));
    },
    // 通用清除表格选中
    _clearSelection() {
      setTimeout(() => {
        this.$refs.staffTable && this.$refs.staffTable.clearSelection();
        this.$refs.selectedStaffTable && this.$refs.selectedStaffTable.clearSelection();
      }, 0);
    },
    //右侧列表检索过滤
    filterRightParam() {
      this.rightDesList = this._filterByKeyword(this.rightList, this.queryRightParam.nickName);
    },
    //左侧列表检索过滤
    filterLeftParam() {
      const filtered = this._filterByKeyword(this.leftList, this.queryLeftParam.nickName);
      this.leftDesList = this._mapWithShowName(filtered);
      this.leftTotal = this.leftDesList.length;
      this.queryLeftParam.pageNum = 1;
    },
    // 获取左侧列表数据（全量加载 + 客户端分页，参考inviteDesigner）
    loadLeftList() {
      this.$api.post({
        url: `/user/desUserList?pageSize=9999`
      }).then(res => {
        this.loadInviteList().then(() => {
          const inviteSet = new Set(this.inviteDesList.map(id => String(id)));
          // 保存全部数据（排除邀约列表），供本地搜索过滤使用
          this.leftList = res.rows.filter(item => !inviteSet.has(String(item.userId)));
          this.leftTotal = this.leftList.length;
          this.leftDesList = this._sliceLeftList();
        })
      }).catch(() => {
        this.leftDesList = [];
        this.leftTotal = 0;
      })
    },
    // 右侧列表获取数据（兼容tempData新格式和旧格式）
    loadRightList() {
      this.rightDesList = [];
      this.$api.get({
        url: '/biz/blockDes/list',
      }).then(res => {
        if (res.data && res.data.length > 0) {
          this.user_id = res.data[0].id;
          if (res.data[0].tempData && res.data[0].tempData.length > 0) {
            // 新格式：tempData数组，包含desUserId和servCataId
            const tempData = res.data[0].tempData;
            // 获取全部设计师列表来补充userCode和nickName
            this.$api.post({
              url: `/user/desUserList?pageSize=9999`
            }).then(des => {
              const allDesList = des.rows;
              tempData.forEach(td => {
                const matched = allDesList.find(d => String(d.userId) === String(td.desUserId));
                if (matched) {
                  this.rightDesList.push({
                    ...matched,
                    nickName: this.showName(matched.nickName),
                    servCataId: td.servCataId || '',
                  });
                }
              });
              this.rightList = [...this.rightDesList];
              this.unChangeRight = [...this.rightDesList];
            });
            return;
          }
          // 旧格式：直接字段映射
          this.rightDesList = res.data.map(item => ({
            userId: item.desUserId,
            userCode: item.desUserCode,
            nickName: item.desUserName,
            servCataId: Array.isArray(item.servCataIds)
              ? item.servCataIds.join(',') : (item.servCataIds || ''),
            id: item.id,
          }));
        }
        this.rightList = [...this.rightDesList];
        this.unChangeRight = [...this.rightDesList];
      }).catch(() => {});
    },
    // 获取邀约列表（兼容tempData新格式和旧格式）
    loadInviteList() {
      return this.$api.get({ url: '/biz/inviteDes/list' }).then(res => {
        this.inviteDesList = [];
        if (!(res.data && res.data.length > 0)) return;
        const d = res.data[0];

        if (d.tempData && d.tempData.length > 0) {
          // tempData可能是JSON字符串，需先解析
          const tempData = typeof d.tempData === 'string' ? JSON.parse(d.tempData) : d.tempData;
          if (tempData.length > 0) {
            this.inviteDesList = tempData.map(item => String(item.desUserId));
          }
        } else if (d.desUserId !== undefined || d.desUserCode !== undefined) {
          // 旧格式1：res.data是设计师记录数组（与blockDesList.vue一致）
          this.inviteDesList = res.data.map(item => String(item.desUserId || item.userId));
        } else {
          // 旧格式2：单条记录含逗号分隔的ID字符串
          const ids = d.desUserIds || d.desUserId || d.userIds || '';
          this.inviteDesList = ids ? String(ids).split(',') : [];
        }
      }).catch(() => {});
    },
    // 行数据的Key
    getRowKey(row) {
      return row.id;
    },
    // 左侧列表翻页（客户端分页）
    leftPageNum(current) {
      this.queryLeftParam.pageNum = current;
      this.leftDesList = this._sliceLeftList();
    },
    // 表格选中变化（左右通用）
    handleStaffChange(rows) {
      this.selectLeftData = rows || [];
    },
    handleSelectedStaffChange(rows) {
      this.selectRightData = rows || [];
    },
    // 左边表格选择项移到右边
    addStaff() {
      this._clearSelection();
      const existingMap = new Map();
      this.rightDesList.forEach((item, index) => existingMap.set(item.userId, index));
      const toAdd = [];
      const duplicates = [];
      this.selectLeftData.forEach(item => {
        if (existingMap.has(item.userId)) {
          const existing = this.rightDesList[existingMap.get(item.userId)];
          const oldIds = (existing.servCataId || '').split(',').filter(Boolean);
          const newIds = (item.servCataId || '').split(',').filter(Boolean);
          existing.servCataId = [...new Set([...oldIds, ...newIds])].join(',');
          const unChangeItem = this.unChangeRight.find(u => u.userId === item.userId);
          if (unChangeItem) unChangeItem.servCataId = existing.servCataId;
          duplicates.push(item.nickName || item.userId);
        } else {
          toAdd.push(item);
        }
      });
      if (duplicates.length) {
        this.$message.warning(`设计师「${[...new Set(duplicates)].join('、')}」已存在，已合并服务单类型`);
      }
      this.rightDesList.push(...toAdd);
      this.unChangeRight.push(...toAdd);
      this.rightList = [...this.rightDesList];
      this.leftTotal = this.leftList.length;
      this.leftDesList = this._sliceLeftList();
      this.queryLeftParam.nickName = '';
    },
    // 右边表格选择项移到左边
    removeStaff() {
      this._clearSelection();
      const removeSet = new Set(this.selectRightData.map(r => r.userId));
      this.unChangeRight = this.unChangeRight.filter(item => !removeSet.has(item.userId));
      this.rightDesList = [...this.unChangeRight];
      this.rightList = [...this.unChangeRight];
      this.queryRightParam.nickName = '';
    },
    // 按钮保存提交
    handleSubmit() {
      const tempData = this.rightDesList.map(item => ({
        desUserId: item.userId,
        servCataId: item.servCataId,
      }));
      this.$api.post({
        url: '/biz/blockDes/save',
        data: { id: this.user_id, tempData }
      }).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.loadRightList();
          this.loadLeftList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 批量添加到右列表
    batchAddToRightList() {
      this.dialogFlag = true;
      this.queryParams.servCataId = [];
      this.queryParams.row = [...this.selectLeftData];
    },
    // 单项添加到右列表
    addItemToRightList(row) {
      this.dialogFlag = true;
      this.queryParams.servCataId = [];
      this.queryParams.row = row.row;
    },
    submitForm() {
      const val = this.queryParams.servCataId;
      // 提取叶子节点ID并去重，用逗号拼接
      const servCataIds = Array.isArray(val) && val.length > 0
        ? [...new Set(val.map(path => path[path.length - 1]))]
        : [];
      if (servCataIds.length === 0) {
        this.$message.warning('请先选择服务单类型');
        return;
      }
      const {row} = this.queryParams;
      const rows = Array.isArray(row) ? row : [row];
      // 设计师按userId去重
      const uniqueRows = [];
      const seenUserIds = new Set();
      rows.forEach(item => {
        if (!seenUserIds.has(item.userId)) {
          seenUserIds.add(item.userId);
          uniqueRows.push(item);
        }
      });
      // 每个设计师一条记录，多个服务单类型用逗号拼接
      const servCataStr = servCataIds.join(',');
      this.selectLeftData = uniqueRows.map(item => ({...item, servCataId: servCataStr}));
      this.addStaff();
      this.dialogFlag = false;
      this.$nextTick(() => {
        this.selectLeftData = [];
      })
    },
    // 单项添加到左对列表
    addItemToLeftList(row) {
      this.selectRightData = [];
      this.selectRightData.push(row.row);
      this.removeStaff();
      this.$nextTick(() => {
        this.selectRightData = [];
      })
    },
    showName(name) {
      if (!name) return '';
      return name[0] + (name.length <= 2 ? '*' : '**');
    },
    getServCataNames(ids) {
      if (!ids || !this.common.category || this.common.category.length === 0) return '';
      const idArr = ids.split(',').filter(Boolean);
      const findName = (list, id) => {
        for (const item of list) {
          if (String(item.servId) === String(id)) return item.servName;
          if (item.children) {
            const found = findName(item.children, id);
            if (found) return found;
          }
        }
        return null;
      };
      const names = idArr.map(id => findName(this.common.category, id)).filter(Boolean);
      return names.join('、');
    }
  },
  created() {
    this.loading = true;
    this.loadLeftList();
    this.loadRightList();
    this.loading = false;
  },
  computed: {
    ...mapState(['common', 'user']),
  },
  components: {
    YShelf,
  }
}
</script>
<style lang="scss" scoped>
.desHeader {
  height: 700px;
}

.transfer {
  width: auto;
  padding: 30px;

  .condition-table {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .el-icon-arrow-left {
    font-size: 21px !important;
    background: #d9d9d9;
    border-radius: 4px;
    color: #fff;
    padding: 2px;
  }

  /deep/ .el-popover__reference-wrapper {
    vertical-align: middle !important;
    padding-left: 4px;
  }

  .icon-right-if .el-icon-arrow-left {
    background: #409eff;
    color: #fff;
  }

  .icon-center {
    i {
      margin-top: 8px;

      &:hover {
        cursor: pointer;
      }
    }

    .icon-return {
      transform: rotate(180deg);
    }
  }

  .no-add {
    display: flex;
    justify-content: space-between;
    height: 35px;
    line-height: 35px;
    font-size: 14px;
    margin-bottom: 10px;
    // background: #F5F7FA;

    span {
      color: #333;
      font-size: 18px;
      margin-left: 20px;
    }
  }
}

.el-transfer-panel__filter {
  width: 100%;
  height: 32px;
  font-size: 12px;
  display: inline-block;
  box-sizing: border-box;
  border-radius: 16px;
  padding-right: 10px;
  margin: 0;
}

.table-footer {
  width: 100%;
  height: 40px;
  border: 1px solid #EBEEF5;
}

.handle-btn {
  margin: 5px 0 0 -75%;
}

.search-position {
  line-height: 33px;
  margin-left: 12px;
}

.order-dialog {
  /deep/ .el-dialog {
    border-radius: 12px;
    overflow: visible;
  }

  /deep/ .el-dialog__body {
    overflow: visible;
  }

  /deep/ input {
    width: 380px;
  }
  /deep/ .order-cascader-popper {
    z-index: 3000 !important;
  }
}
</style>



// WEBPACK FOOTER //
// blockDesList.vue?624f4bbb